export const beaaChatTopics = [
  {
    label: 'Adoção responsável',
    description: 'Animais esperando um lar',
    icon: 'ri-home-heart-line',
  },
  {
    label: 'Castração gratuita',
    description: 'Como participar do programa',
    icon: 'ri-first-aid-kit-line',
  },
  {
    label: 'Animal desaparecido',
    description: 'Cadastrar e ajudar a reencontrar',
    icon: 'ri-search-eye-line',
  },
  {
    label: 'UPAVET',
    description: 'Atendimento veterinário público',
    icon: 'ri-hospital-line',
  },
  {
    label: 'Denúncia de maus-tratos',
    description: 'Como e onde denunciar',
    icon: 'ri-alarm-warning-line',
  },
  {
    label: 'Dados e transparência',
    description: 'Números do bem-estar animal',
    icon: 'ri-bar-chart-box-line',
  },
];

export const beaaChatSuggestions = [
  { id: 'sug-adocao', icon: 'ri-home-heart-line', label: 'Como faço para adotar um animal?' },
  { id: 'sug-castracao', icon: 'ri-first-aid-kit-line', label: 'Quantas castrações já foram feitas?' },
  { id: 'sug-desaparecido', icon: 'ri-search-eye-line', label: 'Perdi meu pet, o que devo fazer?' },
  { id: 'sug-upavet', icon: 'ri-hospital-line', label: 'A UPAVET atende de graça?' },
  { id: 'sug-caderneta', icon: 'ri-booklet-line', label: 'Como funciona a Caderneta Digital?' },
  { id: 'sug-cadastro', icon: 'ri-user-add-line', label: 'Como me cadastro no PETBEA?' },
  { id: 'sug-denuncia', icon: 'ri-alarm-warning-line', label: 'Como denunciar maus-tratos?' },
  { id: 'sug-dados', icon: 'ri-bar-chart-box-line', label: 'Quais os números do bem-estar animal?' },
];

export const beaaChatQuickActions = [
  {
    label: 'Adotar um amigo',
    description: 'Animais esperando um lar',
    icon: 'ri-home-heart-line',
    to: '/goiania/balcao-de-adocao',
  },
  {
    label: 'Animais desaparecidos',
    description: 'Ajude a reencontrar',
    icon: 'ri-search-eye-line',
    to: '/goiania/balcao-de-desaparecidos',
  },
  {
    label: 'Castrômetro',
    description: 'Números da castração',
    icon: 'ri-bar-chart-box-line',
    to: '/goiania/castrometro',
  },
  {
    label: 'UPAVET',
    description: 'Atendimento veterinário',
    icon: 'ri-hospital-line',
    to: '/goiania/upavet',
  },
  {
    label: 'Sobre mim',
    description: 'Minha história e a marca',
    icon: 'ri-information-line',
    to: '/goiania/sobre-a-beaa',
  },
];

export const beaaChatMessages = [
  {
    id: 'msg-1',
    from: 'beaa',
    text: 'Oi! Eu sou a Beaa, a mascote do bem-estar animal de Goiânia. Pode me perguntar qualquer coisa sobre adoção, castração, animais desaparecidos e os serviços da cidade.',
  },
  {
    id: 'msg-2',
    from: 'user',
    text: 'Quantas castrações já foram feitas na cidade?',
  },
  {
    id: 'msg-3',
    from: 'beaa',
    text: 'O programa municipal já passou de 3.452 castrações gratuitas, com mais de 2.847 animais adotados e 1.283 denúncias atendidas. Quer saber como participar da próxima ação?',
  },
];